// import { EditorControls } from './EditorControls'
import { OrbitControls } from '../../../node_modules/three/examples/jsm/controls/OrbitControls'
import ProcessModel from './ProcessModel'
import FileHelper from './FileHelper'
import Envirment from './Envirments/Envirment'
import EventHelper from './EventHelper'
import {
  Scene,
  WebGLRenderer,
  PerspectiveCamera,
  Sphere,
  Box3,
  Vector3,
  Color,
  MeshBasicMaterial,
  Mesh,
  BoxBufferGeometry,
  Matrix4,
  AnimationMixer,
  Clock,
  Math as _Math,
  Group,
} from 'three'
import DiamondManager from './DiamondManager'
import Loader from './loaders/loader'
import {colorData} from './colorData11'

class viewPort {
  constructor(container, options = {}) {
    console.log('createViewPort:', container, options);
    this.scene = new Scene()
    this.renderer = new WebGLRenderer({
      antialias: true,
    })
    this.useAnimation = true
    this.isHolographic = options.isHolographic
    this.fileHelper = new FileHelper()
    this.container = container
    this.renderer.shadowMap.enabled = false
    this.renderer.extensions.get('GL_EXT_shader_texture_lod')
    // getExtension
    this.camera = new PerspectiveCamera(50, 1, 0.1, 100000)
    this.camera.position.set(0, 0, 3)
    this.controls = new OrbitControls(this.camera, this.renderer.domElement)
    // this.controls.rotateSpeed = 0.02
    this.controls.enablePan = false
    this.controls.addEventListener('change', ()=>{
      this.sendCameraParamsToHolographic();
    });

    this.dpr = window.devicePixelRatio
    this.renderer.setPixelRatio(this.dpr)
    this.container.appendChild(this.renderer.domElement)
    this.sceneBoundingSphere = new Sphere(new Vector3(), 0)
    this.sceneBoundingBox = new Box3()
    this.background = new Color()
    this.clock = new Clock()
    // this.controls.initEvents()

    this.useCubeEnvirment = this.renderer.extensions.get(
      'EXT_shader_texture_lod'
    )
      ? true
      : false
    this.envirmentList = []
    for (let i = 0; i < 62; i++) {
      this.envirmentList.push(this.createEnvirments(i))
    }
    this.globalUniforms = {
      envirmentConfig: {
        specularPeak: false,
        envirmentBrightNess: 1.0,
        envirmentRotation: 0,
      },
    }

    this.DiamondManager = new DiamondManager(this)
    this.DiamondManager.initDiamondManager()
    this.Envirment = new Envirment()
    this.envirmentTransFormHelper = new Mesh(
      new BoxBufferGeometry(1, 1, 1),
      new MeshBasicMaterial({
        opacity: 0.001,
        alphaTest: 0.01,
        transparent: true,
        depthWrite: false,
      })
    )
    this.mixer = new AnimationMixer(this.scene)
    this.camera.add(this.envirmentTransFormHelper)
    this.environmentTransform = new Matrix4()
    Loader.loadTexture(require('./diamond/images/1.jpg')).then((texture) => {
      this.scene.background = texture
    })
    this.sceneData = {
      animations: {},
    }
    // debugger

    this.renderer.setClearColor(0x000000)
    this.fitCameraToObject(this.camera)
    this.scene.add(this.camera)
    this.EventHelper = new EventHelper()

    this.sparkleArray = []

    this.initScene()
    this.onWindowResize()
  }

  getObjectMaterial(object) {
    let material = object.material
    return material
  }

  createEnvirments(id) {
    let preFix = 'https://p.gemcool.cn/asset_3d/Envirments/'
    return {
      id: id,
      name: ` Envirment${id}`,
      thumbnail: `${preFix}Envirment${id}/thumbnail_256.jpg`,
      envPath: `${preFix}Envirment${id}/Envirment${id}.zip`,
      envMapCube: `${preFix}Envirment${id}/specular_cubemap_ue4_256_luv.bin.gz`,
      panoramaCube: `${preFix}Envirment${id}/specular_panorama_ue4_1024_luv.bin.gz`,
      config: `${preFix}Envirment${id}/config.json`,
      brdf_ue4: `${preFix}Envirment${id}/brdf_ue4.bin.gz`,
      background_cubemap: `${preFix}Envirment${id}/background_cubemap_256_0.1_luv.bin.gz`,
    }
  }
  async loadEnvirmentFiles(envirmentConfig) {
    let image = await this.fileHelper.requestResource(envirmentConfig.thumbnail)
    let envMapCube = await this.fileHelper.requestResource(
      envirmentConfig.envMapCube
    )
    let panoramaCube = await this.fileHelper.requestResource(
      envirmentConfig.panoramaCube
    )
    let config = await this.fileHelper.requestResource(envirmentConfig.config)
    let fileMap = null
    let path = envirmentConfig.envPath
    if (this.useCubeEnvirment) {
      fileMap = {
        'thumbnail_256.jpg': image,
        'specular_cubemap_ue4_256_luv.bin.gz': envMapCube,
        'config.json': config,
      }
    } else {
      fileMap = {
        'thumbnail_256.jpg': image,
        'specular_panorama_ue4_1024_luv.bin.gz': panoramaCube,
        'config.json': config,
      }
    }
    await this.Envirment.readZipContent(fileMap, path, this.useCubeEnvirment)
  }

  initScene() {
    let modelId = this.getQueryVariable('modelId')
    modelId = decodeURIComponent(modelId)
    let format = modelId.indexOf('glb')
    let format2 = modelId.indexOf('gltf')
    let modelPath = ''
    if (modelId && (format >= 0 || format2 > 0)) {
      modelPath = modelId
    } else {
      modelPath =
        'https://img5.gemtec.ltd/scenes/9031A764-DF6A-4067-BB12-921E5415EBD3.glb'
    }
    // https://img5.gemtec.ltd/scenes/BC1BCA47-3557-48C3-BBDC-169A4B87DDFF.glb
    if (!this.isHolographic)
      this.updateScene(modelPath);
    this.animate()
  }
  updateScene(modelPath) {
    if (!this.isHolographic) {
      const worker = window.ensureSharedWorker();
      worker.port.postMessage({
        source: 'app',
        target: 'holographic',
        type: 'update',
        resType: 0x10,
        url: modelPath,
      });
    }
    this.loadGltfModel(modelPath).then(async (data) => {
      if (data.scene) {
        let root = new Group()
        // let root = data.scene;
        for (let i = 0, j = data.scene.children.length; i < j; i++) {
          root.add(data.scene.children[0])
        }
        if (data._isPreCustomized) {
          this.globalUniforms.envirmentConfig.envirmentBrightNess =
            colorData.envirmentBrightNess
          this.globalUniforms.envirmentConfig.envirmentRotation =
            colorData.envirmentRotation
          await this.setEnvirment(colorData.envirmentIndex)
        } else {
          await this.initSceneEnvirment(data._background)
        }

        let needRemovedObjects = []
        root.traverseVisible((child) => {
          if (child.isMesh && child.material.userData.isDiamondMaterial) {
            let userData = child.material.userData
            this.DiamondManager.createNewDiamondMaterial(
              child,
              child.material.userData.diamondType
            )
            child.material.envMapIntensity =
              userData.DiamondMaterial.envMapIntensity
            child.material.rIndexDelta = userData.DiamondMaterial.rIndexDelta
            child.material.n2 = userData.DiamondMaterial.n2
            child.material.normalOffset = userData.DiamondMaterial.normalOffset
            child.material.squashFactor = userData.DiamondMaterial.squashFactor
            child.material.distanceOffset =
              userData.DiamondMaterial.distanceOffset
            child.material.geometryFactor =
              userData.DiamondMaterial.geometryFactor
            child.material.Absorbption.fromArray(
              userData.DiamondMaterial.Absorbption
            )
            child.material.colorCorrection.fromArray(
              userData.DiamondMaterial.colorCorrection
            )
            child.material.boostFactors.fromArray(
              userData.DiamondMaterial.boostFactors
            )
            child.material.centreOffset.fromArray(
              userData.DiamondMaterial.centreOffset
            )
            child.material.diamondColorCorrection.fromArray(
              userData.DiamondMaterial.diamondColorCorrection
            )
          } else if (child.isLight) {
            needRemovedObjects.push(child)
          } else if (child.isCamera) {
            needRemovedObjects.push(child)
          }
        })

        needRemovedObjects.forEach((item) => {
          item.parent.remove(item)
        })

        this.clearScene();
        this.addObject2Scene(root)
        this.rootGroup = root;
        if (data.animations) {
          this.addAnimation(this.scene, data.animations)
          this.playAnimation()
        }

        if (!this.useAnimation) {
          this.render()
        }
      }
    })
  }
  clearScene() {
    if (!this.rootGroup)
      return;
    this.rootGroup.traverse((child)=>{
      if (child.geometry)
        child.geometry.dispose();
      if (child.material)
        child.material.dispose();
    });
    this.scene.remove(this.rootGroup);
    delete this.rootGroup;
  }
  addAnimation(_object, animations) {
    if (animations !== undefined && animations.length > 0) {
      // let firstAnimation;
      let object = this.scene
      animations.forEach((animation, index) => {
        //动画节点记录动画
        animation.animationId = this.generateUUID()
        this.sceneData.animations[animation.uuid] = {
          id: animation.uuid,
          name: animation.name,
          animation: this.mixer.clipAction(animation, object),
          uuid: object.uuid,
          oriAnimation: animation,
        }

        object = _object
      })
    }
  }
  generateUUID() {
    return _Math.generateUUID()
  }
  findObjectByAnimationId(animationId, object) {
    let result = null
    object.traverse((child) => {
      if (
        child.userData.animationId &&
        child.userData.animationId === animationId
      ) {
        result = child
      }
    })
    return result
  }
  playAnimation() {
    for (let name in this.sceneData.animations) {
      this.sceneData.animations[name].animation.play()
    }
    this.useAnimation = true
  }

  async loadGltfModel(path, format) {
    return ProcessModel.loadModel({
      model: {
        path: path,
        type: format || 'glb',
      },
    })
  }
  sendCameraParamsToHolographic() {
    if (!this.isHolographic) {
      const worker = window.ensureSharedWorker();
      const camera = this.camera;
      worker.port.postMessage({
        source: 'app',
        target: 'holographic',
        type: 'update3DCamera',
        position: {
          x: camera.position.x,
          y: camera.position.y,
          z: camera.position.z,
        },
        quaternion: {
          x: camera.quaternion.x,
          y: camera.quaternion.y,
          z: camera.quaternion.z,
          w: camera.quaternion.w,
        },
        fov: camera.fov,
      });
    }
  }
  fitCameraToObject(camera, offset) {
    offset = offset || 1.25
    let boundingBoxes = []
    this.sceneBoundingBox.makeEmpty()
    this.scene.traverse((child) => {
      if (child.isMesh && !child.isBackGround) {
        let boundingBox = new Box3()
        if (!child.geometry.boundingBox) {
          child.geometry.computeBoundingBox()
        }
        boundingBox.copy(child.geometry.boundingBox)
        child.updateMatrixWorld(true) // ensure world matrix is up to date
        boundingBox.applyMatrix4(child.matrixWorld)
        boundingBoxes.push(boundingBox)
      }
    })
    for (let i = 0; i < boundingBoxes.length; i++) {
      this.sceneBoundingBox.union(boundingBoxes[i])
    }
    this.sceneBoundingBox.getBoundingSphere(this.sceneBoundingSphere)
    const boundingBox = this.sceneBoundingBox
    const center = boundingBox.getCenter()
    const size = boundingBox.getSize()
    // get the max side of the bounding box (fits to width OR height as needed )
    const maxDim = Math.max(size.x, size.y, size.z)
    const fov = camera.fov * (Math.PI / 180)
    let cameraZ = Math.abs((maxDim / 2) * Math.tan(fov * 2))

    cameraZ *= offset // zoom out a little so that objects don't fill the screen

    camera.position.z = center.z + (cameraZ <= 0.1 ? 0.1 : cameraZ)
    camera.position.y = center.y
    camera.position.x = center.x
    // camera.updateProjectionMatrix()
    camera.lookAt(center)
    this.controls.target.copy(center);
    this.controls.update();
    if (typeof this.onCameraFitToObject === 'function') {
      this.onCameraFitToObject(center, cameraZ);
    }
    this.sendCameraParamsToHolographic();
    if (!this.useAnimation) {
      this.render()
    }
  }
  getQueryVariable(variable) {
    let query = window.location.search.substring(1)
    let vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=')
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    return null
  }

  async initSceneEnvirment(background) {
    if (background) {
      let envirment = background.envirment
      let index = this.getEnvirmentIndexById(envirment.id)
      await this.setEnvirment(index)
      this.globalUniforms.envirmentConfig.specularPeak = background.specularPeak
      this.globalUniforms.envirmentConfig.envirmentBrightNess =
        background.envirmentBrightNess
      this.globalUniforms.envirmentConfig.envirmentRotation =
        background.envirmentRotation
    } else {
      await this.setEnvirment(0)
    }

    this.updateEnvirmantRotation(
      this.globalUniforms.envirmentConfig.envirmentRotation
    )
  }
  getEnvirmentIndexById(envirmentId) {
    for (let i = 0, j = this.envirmentList.length; i < j; i++) {
      if (envirmentId == this.envirmentList[i].id) {
        return i
      }
    }
  }
  addObject2Scene(object, parent, index) {
    object.traverse((child) => {
      object.updateMatrixWorld(true)
      if (child.isMesh) {
        child.material.needsUpdate = true

        if (child.material.isPBRShaderMaterial) {
          child.material.uniforms.uEnvironmentTransform.value = this.environmentTransform
          this.useEnvirmentMap(child)
        }
      }
    })
    this.DiamondManager.ensureDiamondCustomScene(object)
    if (parent === undefined) {
      this.scene.add(object)
    } else {
      parent.children.splice(index, 0, object)
      object.parent = parent
    }
    this.computeSceneBoundingBox()

    this.fitCameraToObject(this.camera, 1.0)
    this.onWindowResize()
  }

  updateEnvirmantRotation(rotation) {
    //旋转模型环境贴图
    this.fromRotation(this.envirmentTransFormHelper.matrix.elements, rotation, [
      0,
      1,
      0,
    ])
    this.envirmentTransFormHelper.matrix.decompose(
      this.envirmentTransFormHelper.position,
      this.envirmentTransFormHelper.quaternion,
      this.envirmentTransFormHelper.scale
    )
  }
  fromRotation(out, rad, axis) {
    var x = axis[0],
      y = axis[1],
      z = axis[2],
      len = Math.sqrt(x * x + y * y + z * z),
      s,
      c,
      t

    if (Math.abs(len) < 1e-10) {
      return null
    }

    len = 1 / len
    x *= len
    y *= len
    z *= len

    s = Math.sin(rad)
    c = Math.cos(rad)
    t = 1 - c

    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c
    out[1] = y * x * t + z * s
    out[2] = z * x * t - y * s
    out[3] = 0
    out[4] = x * y * t - z * s
    out[5] = y * y * t + c
    out[6] = z * y * t + x * s
    out[7] = 0
    out[8] = x * z * t + y * s
    out[9] = y * z * t - x * s
    out[10] = z * z * t + c
    out[11] = 0
    out[12] = 0
    out[13] = 0
    out[14] = 0
    out[15] = 1
    return out
  }

  computeSceneBoundingBox() {
    let boundingBoxes = []
    this.sceneBoundingBox.makeEmpty()
    this.scene.traverse((child) => {
      if (child.isMesh) {
        let boundingBox = new Box3()
        if (!child.geometry.boundingBox) {
          child.geometry.computeBoundingBox()
        }
        boundingBox.copy(child.geometry.boundingBox)
        child.updateMatrixWorld(true) // ensure world matrix is up to date
        boundingBox.applyMatrix4(child.matrixWorld)
        boundingBoxes.push(boundingBox)
      }
    })
    for (let i = 0; i < boundingBoxes.length; i++) {
      this.sceneBoundingBox.union(boundingBoxes[i])
    }
    this.sceneBoundingBox.getBoundingSphere(this.sceneBoundingSphere)
  }

  //给mesh赋值环境球，添加环境光照
  useEnvirmentMap(mesh) {
    // mesh.material.envMap = this.Envirment._cubemapUE4['LUV'].cubeMap;
    if (mesh.isHelpObject) {
      return
    }
    let brightNess = this.globalUniforms.envirmentConfig.envirmentBrightNess
    if (!mesh || !mesh.material || !mesh.material.isPBRShaderMaterial) {
      return
    }
    mesh.material.uniforms.uEnvironmentTransform.value = this.environmentTransform
    if (this.useCubeEnvirment) {
      let envirmentConfig = this.globalUniforms.envirmentConfig
      mesh.material.envMap = this.Envirment._cubemapUE4['LUV'].cubeMap
      mesh.material.uSpecularPeak = envirmentConfig.specularPeak ? 1 : 0
      mesh.material.uTextureEnvironmentSpecularPBRLodRange.set(
        this.Envirment._cubemapUE4.nbLod,
        this.Envirment._cubemapUE4.maxLod
      )
      mesh.material.uTextureEnvironmentSpecularPBRTextureSize.set(256, 256)
      delete mesh.material.defines['PANORAMA_ENVIRMENT']
    } else {
      mesh.material.envMap = this.Envirment._panoramaUE4['LUV'].envMap
      mesh.material.uTextureEnvironmentSpecularPBRLodRange.set(
        this.Envirment._panoramaUE4.nbLod,
        this.Envirment._panoramaUE4.maxLod
      )
      mesh.material.defines['PANORAMA_ENVIRMENT'] = ''
      mesh.material.uTextureEnvironmentSpecularPBRTextureSize.set(1024, 1024)
    }
    mesh.material.uEnvironmentExposure = brightNess
    // debugger
    mesh.material.envMap.needsUpdate = true
    mesh.material.uDiffuseSPH = this.Envirment._spherical.sphCoef
    // mesh.material.sIntegrateBRDF = this.Envirment._integrateBRDF.brdfTexture;
    mesh.material.needsUpdate = true
    if (!this.useAnimation) {
      this.render()
    }
  }
  //设置环境球
  async setEnvirment(index) {
    let envirment = this.envirmentList[index]
    await this.loadEnvirmentFiles(envirment)
    if (!this.useAnimation) {
      this.render()
    }
  }

  onWindowResize() {
    if (this.width !== this.container.offsetWidth || this.height !== this.container.offsetHeight) {
      this.width = this.container.offsetWidth
      this.height = this.container.offsetHeight
      this.camera.aspect = this.width / this.height
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.width, this.height)
      if (typeof this.onResize === 'function')
        this.onResize(this.width, this.height);
    }
    // if (!this.useAnimation) {
    //   this.render()
    // }
    // this.updateRender = true;
  }
  update() {
    this.onWindowResize()
    if (typeof this.onUpdate === 'function')
      this.onUpdate()
  }
  render() {
    this.renderer.render(this.scene, this.camera)
  }
  animate() {
    requestAnimationFrame(this.animate.bind(this))
    let mixer = this.mixer

    if (mixer.stats.actions.inUse > 0) {
      mixer.update(this.clock.getDelta())
    }
    this.update()
    this.render()
  }
}
export default viewPort
